import { Routes } from '@angular/router';
import { AuthGuard } from './auth-guard';

export const routes: Routes = [
  // Public login page (lazy-loaded)
  {
    path: 'login',
    loadComponent: () =>
      import('./login/login-component').then(m => m.LoginComponent)
  },

  // Authenticated area
  {
    path: '',
    canActivate: [AuthGuard],       // Protect the layout itself
    canActivateChild: [AuthGuard],  // Protect all children
    loadComponent: () =>
      import('./sales-funnel-layout.component').then(m => m.SalesFunnelLayout),
    children: [
      // Default landing page when authenticated
      { path: '', pathMatch: 'full', redirectTo: 'project-management' },

      {
        path: 'project-management',
        loadComponent: () =>
          import('./project-management/project-management.component')
            .then(m => m.ProjectManagementComponent)
      },
      {
        path: 'civil-works',
        loadComponent: () =>
          import('./civil-works/civil-works.component')
            .then(m => m.CivilWorksComponent)
      },
      {
        path: 'data-enrichment',
        loadComponent: () =>
          import('./data-enrichment/data-enrichment.component')
            .then(m => m.DataEnrichmentComponent)
      },
      {
        path: 'workforce-management',
        loadComponent: () =>
          import('./workforce-management/workforce-management.component')
            .then(m => m.WorkforceManagementComponent)
      },
      {
        path: 'finance',
        loadComponent: () =>
          import('./finance/finance.component')
            .then(m => m.FinanceComponent)
      },
      {
        path: 'ticket-management',
        loadComponent: () =>
          import('./ticket-management/ticket-management.component')
            .then(m => m.TicketManagementComponent)
      }
    ]
  },

  // Catch-all: redirect to login if unknown route
  { path: '**', redirectTo: 'login' }
];
